import React from "react";
import { ClientInformationProvider } from "../../Context/ClientInformation";
import CallClientInformationForm from "./CallClientInformationForm";

const MainClientInformation = () => {
  return (
    <ClientInformationProvider>
      <CallClientInformationForm />
    </ClientInformationProvider>
  );
};

export default MainClientInformation;
